import axios from 'axios'
import React, {useEffect, useState} from 'react'
import * as TypIcons from 'react-icons/ti'
import { useParams } from 'react-router'
import { Link, useNavigate } from 'react-router-dom'
import authService from '../../../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  TitlePage2
} from '../../../Components/Main'
//import padrao from 'profile.png'
import ProfileDireita from '../../../Components/ProfileDireita'
import SidebarMobile from '../../../Components/SideBar-right/SidebarMobile'
import '../../../styles/pages/SubMenuPages/SubMenuTipoDeObservacao/QuestoesTiposDeQuestoes/TQOQuestoesReg.css'
import ModalEditar from './modalTiposDeObservacoes/modalEditarQuestao'
import Modal from './modalTiposDeObservacoes/modalNovaQuestao'

function ChecklistQuestoes() {
  var user = authService.getCurrentUser()
  const history = useNavigate()
  var user = authService.getCurrentUser()
  let id = useParams<{IdObservacaoSubGrupo: string}>()
  sessionStorage.IdObservacaoSubGrupo = id.IdObservacaoSubGrupo

  // console.log('IdObservacaoTipoEdit: ' + sessionStorage.IdObservacaoTipoEdit)
  // console.log('IdObservacaoGrupoEdit: ' + sessionStorage.IdObservacaoGrupoEdit)
  // console.log('IdObservacaoSubGrupoEdit: ' + sessionStorage.IdObservacaoSubGrupo)

  const [observacaoTipo, setObservacaoTipo] = useState<any[]>([])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/observacaotipo/' +
        sessionStorage.IdObservacaoTipoEdit
      )
      .then(response => {
        //console.log('observacaoTipo: ' + response.data)
        setObservacaoTipo(response.data)
      })
      .catch(error => {
        console.error('Erro ao buscar o tipo de observação:', error)
      })
  }, [])

  const [grupoQuestao, setGrupoQuestao] = useState<any[]>([])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/observacaogrupo/' +
        sessionStorage.IdObservacaoGrupoEdit
      )
      .then(response => {
        setGrupoQuestao(response.data)
      })
      .catch(error => {
        console.error('Erro ao buscar o grupo de observação:', error)
      })
  }, [])
  
  const [subGrupoQuestao, setSubGrupoQuestao] = useState<any[]>([])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/observacaosubgrupo/' +
        sessionStorage.IdObservacaoSubGrupo
      )
      .then(response => {
        setSubGrupoQuestao(response.data)
      })
      .catch(error => {
        console.error('Erro ao buscar o subgrupo de observação:', error)
      })
  }, [])
  
  const [questoes, setQuestoes] = useState<any[]>([])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/observacaoquestao/list/' +
        user[0].IdEmpresa +
        '/' +
        id['IdObservacaoSubGrupo']
      )
      .then(response => {
        setQuestoes(response.data)
      })
      .catch(error => {
        console.error('Erro ao buscar as questões de observação:', error)
      })  
  }, [])

  const uniques = questoes
    .map(item => item.ogrDescricao)
    .filter((value, index, self) => self.indexOf(value) === index)
  const [searchTerm, setSearchTerm] = useState('')

  const [modal, setModal] = useState(false)
  const toggleModal = () => {
    setModal(!modal)
  }
  function handleToggleComplete(objetos = []) {
    setModalInfo(objetos)
    setModalOpen(true)
  }
  const [modalOpen, setModalOpen] = useState(false)

  const [image, setImage] = useState('')
  var user = authService.getCurrentUser()
  var img = new Image()
  img.src = user[0].pesFoto
  // Se foi possível carregar a imagem
  img.onload = () => {
    setImage(user[0].pesFoto)
  }
  // Caso não seja possível
  img.onerror = () => {
    setImage('profile')
  }
  const [sidebar, setSidebar] = useState(false)
  const showSidebar = () => setSidebar(!sidebar)
  const [toogle, setToogle] = React.useState(false)
  const [modalInfo, setModalInfo] = useState([])

  console.log(questoes)
  
  return (
    <div className='displayInteract'>
      {modalOpen && (
        <ModalEditar setOpenModal={setModalOpen} modalInfo={modalInfo}/>
        )}

      <ContainerPage>
        <div id='containerHead1'>
          <div className="logo" style={{ width: '200px', height: '80px' }} />
        </div>
        <div id="containerHead2">
        <TitleOfPage>
          <TitlePage1>
            {observacaoTipo[0]?.otpDescricao} / {grupoQuestao[0]?.ogrDescricao} / {subGrupoQuestao[0]?.sbgDescricao ?? 'NI'} / QUESTÕES:
          </TitlePage1>
          <TitlePage2>
            {/* Questões de : {uniques[0]} */}
          </TitlePage2>
        </TitleOfPage>

        <div id='containerPesquisaModal'>
          <input
            className="fCxPesquisa"
            placeholder="Pesquisar"
            type="text"
            id="pesquisar"
            name="pesquisar"
            onChange={event => {
              setSearchTerm(event.target.value)}}
          />
          <Modal />
        </div>
        </div>

        <div className="tabelaPadrao">
          <table>
            <thead>
              <th style={{ textAlign: 'center'}}>Editar</th>
              <th style={{ textAlign: 'center'}}>Ordem</th>
              <th>Questão</th>
              <th style={{ textAlign: 'center'}}>Status</th>
            </thead>
            <tbody>
              {questoes
                .filter(val => {
                  if(searchTerm === '') {
                    return val
                  } else if (
                    val.oqsDescricao
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  ) {
                    return val
                  }
                })
                .map(questao => (
                  <tr>
                    <td onClick={() => handleToggleComplete(questao)}>
                      <button className="btnPageGroupQuest">
                        <i className="fas fa-edit"></i>
                      </button>
                    </td>
                    <td style={{ textAlign: 'center'}}>
                      <label>{questao.oqsNumero}</label>
                    </td>
                    <td>
                      <label>{questao.oqsDescricao}</label>
                    </td>
                    <td style={{ textAlign: 'center'}}>
                      <input
                        type="checkbox"
                        defaultChecked={!!questao.oqsStatus}
                        disabled
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </ContainerPage>

      <button
        className="btnReturn"
        type="button"
        onClick={() => history(-1)}>
        <TypIcons.TiArrowBackOutline />
      </button>

      <nav className="esconderFiltro">
        <ProfileDireita />

        {user[0].gruDescricao === 'Humanit' ? (
          <SidebarMobile />
        ) : user[0].gruDescricao === 'Administrativo' ? (
          <SidebarMobile />
        ) : user[0].gruDescricao === 'Administrador' ? (
          <SidebarMobile />
        ) : (
          <div></div>
        )}
      </nav>
    </div>
  )
}

export default ChecklistQuestoes